import { Box, Typography } from "@mui/material";
import { FC } from "react";

import InputField from "../../../../common/Form/Input/InputField";
import FileUploadButton from "../../../../common/Form/FileUpload/FileUploadButton";
import { DATE_OF_APPOINTMENT, DATE_OF_TENURE_COMPLETION, SIGNED_CONFIDENTIALITY_AGREEMENT, SIGNED_CONFLICT_OF_INTEREST } from "../../../../../constants/forms";

const TermsOfAppointment: FC = (): JSX.Element => {

    return (
        <>
            <InputField label={"2.1  Date of Appointment"} name={DATE_OF_APPOINTMENT} placeholder={"Date of appointment"} type="date" />

            <InputField label={"2.2  Date of Tenure Completion"} name={DATE_OF_TENURE_COMPLETION} placeholder={"Date of tenure completion"} type="date" />

            <Box className="mg-b-50">
                <label className="form-label mg-b-20">2.3  Signed Confidentiality Agreement <Typography variant={"subtitle1"} component={"span"} color={"secondary"}>(Previous document)</Typography></label>
                <FileUploadButton name={SIGNED_CONFIDENTIALITY_AGREEMENT} label="Upload here..." className="mg-t-0" />
            </Box>

            <Box className="mg-b-50">
                <label className="form-label mg-b-20">2.4  Signed Conflict of Interest <Typography variant={"subtitle1"} component={"span"} color={"secondary"}>(Previous document)</Typography></label>
                <FileUploadButton name={SIGNED_CONFLICT_OF_INTEREST} label="Upload here..." className="mg-t-0" />
            </Box>
        </>
    )
}

export default TermsOfAppointment;